import { render, staticRenderFns } from "./ChangeDevicesBase.vue?vue&type=template&id=be70d678"
import script from "./ChangeDevicesBase.vue?vue&type=script&lang=ts"
export * from "./ChangeDevicesBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports